/**
 * Who works free accounts' cases once they start, shown on the bill page
 * (2026-10-27). Change it here. Add a photo by dropping it in
 * public/images/team/ and setting photo, until then it shows initials.
 */
export const SPECIALIST = {
  name: 'Chris',
  role: 'Billing specialist',
  photo: null as string | null,
  line: 'Your point of contact from the day you start your case.',
};
